import helper from '../helper';
import notification from '../notification';
import inputs from '../inputs';
import checkValidity from '../form-validation/check-validity';

class JSForm {
    constructor(selector) {
        let _this = this;

        $(document).on('click', selector + '-new-message', _this.newMessage);

        $(document).on('submit', selector, _this.defaultFormSubmit);

        $(document).on(
            'submit',
            selector + '-cancel-order',
            _this.cancelOrderFormSubmit
        );
    }

    defaultFormSubmit(e) {
        e.preventDefault();

        let $form = $(e.target);
        let isValidForm = checkValidity($form);

        if (isValidForm) {
            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: $form.serialize(),
                beforeSend() {
                    $form.find('[type=submit]').prop('disabled', true);
                },
                success(data) {
                    var unknownErrors = [];

                    if (
                        data.result &&
                        data.result === 'fail' &&
                        data.exception !== undefined
                    ) {
                        return notification({
                            status: 'error',
                            message: data.exception,
                        });
                    }

                    if (
                        data.fieldErrors &&
                        Object.keys(data.fieldErrors).length
                    ) {
                        for (var key in data.fieldErrors) {
                            var error = data.fieldErrors[key];
                            var input = $form.find("[name='" + key + "']");

                            if (input.length) {
                                helper.showFieldError(input, error);
                            } else {
                                unknownErrors[unknownErrors.length] = error;
                            }
                        }
                        console.log(unknownErrors);
                    } else if (data.result && data.result === 'success') {
                        if (data.url !== null && data.url !== undefined) {
                            return (window.location.href = data.url);
                        }

                        $form.parent().addClass('sst-callback--sent');
                    }
                },
                error(xhr, ajaxOptions, trowError) {
                    $form
                        .parent()
                        .addClass('sst-callback--sent sst-callback--fail');
                },
                complete(data) {
                    $form.find('[type=submit]').prop('disabled', false);
                },
            });
        }
    }

    newMessage(e) {
        let parent = $(e.target).closest('.sst-callback--sent');
        parent
            .find('input:visible, textarea:visible')
            .each(function (index, el) {
                $(el).val('');
                inputs.checkDirty(el);
                if ($(el).hasClass('sst-autoheight')) {
                    inputs.calcAutoheight(el);
                }
            });
        parent.removeClass('sst-callback--sent');
    }

    cancelOrderFormSubmit(e) {
        e.preventDefault();
        let $form = $(e.target);

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize(),
            beforeSend() {
                $form.find('[type=submit]').prop('disabled', true);
            },
            success(data) {
                if (
                    data.result &&
                    data.result === 'fail' &&
                    data.exception !== undefined
                ) {
                    $form.find('[type=submit]').prop('disabled', false);
                    return notification({
                        status: 'error',
                        message: data.exception,
                    });
                }

                if (data.result && data.result === 'success') {
                    $form.replaceWith(
                        '<div class="sst-disabled sst-button sst-button--primary sst-button--radius sst-button--material sst-button--padding">Заказ отменен</div>'
                    );
                }
            },
            error(xhr, ajaxOptions, trowError) {
                $form.find('[type=submit]').prop('disabled', false);
                return notification({ status: 'error', message: trowError });
            },
        });
    }
}

export default JSForm;
